import React from 'react';
import { formatShortDate } from '../../utils/date-utils';

export default function ConflictWarnings({ conflicts = [] }) {
  if (!conflicts || conflicts.length === 0) {
    return null;
  }

  return (
    <div style={{
      padding: '12px 16px',
      background: '#fef3c7',
      border: '1px solid #fbbf24',
      borderRadius: '8px',
      marginBottom: '16px'
    }}>
      <div style={{
        fontSize: '13px',
        fontWeight: '600',
        color: '#92400e',
        marginBottom: '8px',
        display: 'flex',
        alignItems: 'center',
        gap: '6px'
      }}>
        <span>⚠️</span>
        <span>Scheduling Conflicts Detected</span>
      </div>

      <div style={{
        fontSize: '12px',
        color: '#78350f',
        marginBottom: '8px'
      }}>
        The following jobs may overlap with this assignment:
      </div>

      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px'
      }}>
        {conflicts.map((conflict, index) => (
          <div
            key={index}
            style={{
              padding: '10px',
              background: 'white',
              borderRadius: '6px',
              border: '1px solid #fbbf24'
            }}
          >
            <div style={{
              fontSize: '13px',
              fontWeight: '600',
              color: '#2b2b2b',
              marginBottom: '4px'
            }}>
              #{conflict.contractNumber} - {conflict.customerName}
            </div>

            <div style={{
              fontSize: '12px',
              color: '#666',
              marginBottom: '2px'
            }}>
              📍 {conflict.name}
            </div>

            {conflict.scheduledDate && (
              <div style={{
                fontSize: '12px',
                color: '#666'
              }}>
                📅 Scheduled: {formatShortDate(conflict.scheduledDate)}
                {conflict.durationDays > 1 && ` (${conflict.durationDays} days)`}
              </div>
            )}

            {conflict.assignedCrew && (
              <div style={{
                fontSize: '12px',
                color: '#666'
              }}>
                👷 {conflict.assignedCrew}
              </div>
            )}
          </div>
        ))}
      </div>

      <div style={{
        fontSize: '11px',
        color: '#92400e',
        marginTop: '8px',
        fontStyle: 'italic'
      }}>
        You can still proceed, but consider adjusting the schedule or crew assignment.
      </div>
    </div>
  );
}